export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/AiNumberReader.worker.48925fcb.worker.js");
}
